import { DdEventCategory, DdEventType } from '../types';
import { logFanduelInfo } from './clientInitialisation';
import { Logger } from './rumEvents';

export enum JackpotReconActionsNames {
  MANUAL_RECON_START = '[GW][RECON] Manual jackpot reconciliation started',
  RECON_DELIVERY = '[GW][RECON] Jackpot reconciliation delivered',
  AUTO_RECON_START = '[GW][RECON] Auto jackpot reconciliation started',
  RECON_POSTPONED = '[GW][RECON] Jackpot reconciliation postponed',
}

export const ddNotifyJackpotReconStart = (
  auto = false,
  context: Record<string, unknown> = {},
) => {
  const actionName = auto
    ? JackpotReconActionsNames.AUTO_RECON_START
    : JackpotReconActionsNames.MANUAL_RECON_START;
  logFanduelInfo(actionName);
  Logger.logRumAction({
    name: actionName,
    useCase: DdEventCategory.JackpotRecon,
    eventType: DdEventType.Success,
    context,
  });
};

export const ddNotifyJackpotReconPostponed = (
  context: Record<string, unknown> = {},
) => {
  logFanduelInfo(JackpotReconActionsNames.RECON_POSTPONED);
  Logger.logRumAction({
    name: JackpotReconActionsNames.RECON_POSTPONED,
    useCase: DdEventCategory.JackpotRecon,
    eventType: DdEventType.Success,
    context,
  });
};

export const ddNotifyJackpotReconDelivery = (
  context: Record<string, unknown> = {},
) => {
  logFanduelInfo(JackpotReconActionsNames.RECON_DELIVERY);
  Logger.logRumAction({
    name: JackpotReconActionsNames.RECON_DELIVERY,
    useCase: DdEventCategory.JackpotRecon,
    eventType: DdEventType.Success,
    context,
  });
};
